export default __webpack_public_path__ + "a3f999199da9bc7671b21530e369edd2.svg";